/**
 * @file 账号用量账单搜索表单mixin
 */
import { mapState } from 'vuex';
import { getCurrentMonthTimestamp } from '@/utils/utils';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      conditionFilter: {
        dateRange: getCurrentMonthTimestamp(), // 账单日期
        billItem: ['all'], // 计费项
        keyword: '', // 关键词,
        email: '',
        channelId: '',
        status: ''
      },
      dataSource: {
        contents: [],
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0
      },
      limitPickerMonthTimestamp: getCurrentMonthTimestamp()[0]
    };
  },
  computed: {
    ...mapState({
      billDictionary: state => state.account.billDictionary, // 计费项字典
      overViewInfo: state => state.account.overViewInfo
    }),
    // 产品项列表
    productOptions() {
      const options = [{
        label: '全部',
        value: 'all'
      }];
      const chargeType = this.overViewInfo.chargeType;
      let billDictionary;
      if (chargeType && chargeType !== 'minutes') {
        billDictionary = this.formatSelectData(1, 2);
      } else {
        billDictionary = this.formatSelectData(7);
      }
      billDictionary.map((product, index) => {
        options.push({
          label: product.name,
          value: index,
          children: [
            { label: '全部', value: 'all' },
            ...product.itemList.map(item => ({
              label: item.name === '并发包月' ? '并发' : item.name,
              value: item.id
            }))
          ]
        });
      });
      return options;
    },
    paymentStatusOptions() {
      return [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已支付',
          value: 5
        },
        {
          label: '待支付',
          value: 6
        }
      ];
    }
  },
  methods: {
    filterDisabledMonth(date) {
      const firstPickeredMonth = this.limitPickerMonthTimestamp;
      if (!firstPickeredMonth) return false;

      // 限制在 12 个月内，起点为 2024.01，最多选到 2023.02 和 2024.12
      const minMonth = dayjs(firstPickeredMonth).subtract(12, 'month').endOf('month').valueOf() + 1;
      const maxMonth = dayjs(firstPickeredMonth).add(12, 'month').valueOf() - 1;

      return date < minMonth || date > maxMonth;
    },
    onMonthPicker(params) {
      this.limitPickerMonthTimestamp = params.minDate.getTime();
    },
    // 过滤下拉框
    formatSelectData(firstFilterId, secondFilterId) {
      let formatData = [];
      const billDictionary = JSON.parse(JSON.stringify(this.billDictionary));
      formatData = billDictionary.map(product => {
        return product.itemList.filter(item => {
          if (!secondFilterId) {
            return item.id !== firstFilterId;
          }
          return !(item.id === firstFilterId || item.id === secondFilterId);
        });
      });
      formatData.map((item, index) => {
        billDictionary[index].itemList = item;
      });
      return billDictionary;
    },
    getSearchParams(unionId) {
      const { dateRange, keyword, email, channelId, status } = this.conditionFilter;
      const { pageNumber, pageSize } = this.dataSource;
      const itemIds = this.computeItemId();
      const [startDate, endDate] = dateRange;
      const params = {
        pageNumber,
        pageSize,
        itemIds,
        startDate,
        endDate: dayjs(endDate).endOf('month').valueOf()
      };
      if (channelId) {
        params.channelId = channelId;
      }
      if (unionId) {
        params.unionId = unionId;
      }
      if (keyword) {
        params.keyword = keyword;
      }
      if (email) {
        params.email = email.trim();
      }
      if (status !== '') {
        params.status = Number(status);
      }
      return params;
    },
    normalizePaymentStatus(status) {
      return Number(status) === 6 ? 6 : 5;
    },
    formatPaymentStatus(status) {
      return this.normalizePaymentStatus(status) === 6 ? '待支付' : '已支付';
    },
    getTableValue(prop, rowData) {
      switch (prop) {
        case 'cousumeDate':
          return this.formatDateValue(rowData.cousumeDate);
        case 'univalence':
        case 'cost':
          return this.formatAmountValue(rowData[prop]);
        case 'status':
          return this.formatPaymentStatus(rowData.status);
        default:
          return this.getValue(rowData[prop]);
      }
    },
    formatAmountValue(value) {
      if (this.isEmpty(value)) {
        return '-';
      }
      const amount = Number(value);
      return Number.isNaN(amount) ? value : amount / 100000;
    },
    formatDateValue(value) {
      if (this.isEmpty(value)) {
        return '-';
      }
      const date = dayjs(value);
      return date.isValid() ? date.format('YYYY-MM-DD') : value;
    },
    getValue(value) {
      return this.isEmpty(value) ? '-' : value;
    },
    isEmpty(value) {
      return value === undefined || value === null || value === '';
    },
    computeItemId() {
      const { billItem } = this.conditionFilter;
      const itemIds = [];
      const [productValue, billValue] = billItem;
      if (productValue === 'all') {
        this.billDictionary.map((product) => {
          product.itemList.forEach(item => {
            itemIds.push(item.id);
          });
        });
      } else if (billValue === 'all') {
        const cProduct = this.billDictionary.find((product, index) => (index) === productValue);
        cProduct.itemList.forEach(item => {
          itemIds.push(item.id);
        });
      } else {
        itemIds.push(billValue);
      }
      return itemIds.join(',');
    },
  }
};
